import { openDB } from "idb";

// Database Initialization
let dbPromise = null;

const getDB = async () => {
  if (!dbPromise) {
    dbPromise = openDB("BillingDB", 4, {
      upgrade(db, oldVersion) {
        const stores = [
          { name: "users", key: "user_id", version: 1 },
          { name: "invoices", key: "invoice_id", version: 2 },
          { name: "sales_invoices", key: "invoice_id", version: 3 },
          { name: "purchase", key: "purchase_id", version: 4 },
        ];
        stores.forEach(({ name, key, version }) => {
          if (oldVersion < version && !db.objectStoreNames.contains(name)) {
            db.createObjectStore(name, { keyPath: key });
          }
        });
      },
    });
  }
  return dbPromise;
};

// Generic IndexedDB Handler
const dbHandler = {
  async execute(storeName, action, data = null) {
    try {
      const db = await getDB();
      const mode = action === "getAll" ? "readonly" : "readwrite";
      const tx = db.transaction(storeName, mode);
      const store = tx.store;

      let result;
      switch (action) {
        case "add":
          result = await store.add(data);
          console.log(`✅ ${storeName} saved:`, data);
          break;
        case "getAll":
          result = await store.getAll();
          console.log(`🔍 Fetched unsynced ${storeName}:`, result);
          break;
        case "delete":
          result = await store.delete(data);
          console.log(`✅ ${storeName} removed:`, data);
          break;
        default:
          throw new Error("Invalid action");
      }
      await tx.done;
      return result;
    } catch (error) {
      console.error(`❌ ${storeName} ${action} failed:`, error);
      return action === "getAll" ? [] : null;
    }
  },
};

// Reusable Store Component
const createStore = (storeName) => ({
  add: (data) => dbHandler.execute(storeName, "add", data),
  getUnsynced: () => dbHandler.execute(storeName, "getAll"),
  remove: (id) => dbHandler.execute(storeName, "delete", id),
});

// Export Reusable DB Object
export const db = {
  users: createStore("users"),
  invoices: createStore("invoices"),
  sales_invoices: createStore("sales_invoices"),
  purchase: createStore("purchase"),
};
